import { RequestStatus } from "./RequestStatus";

export type Template = {
  id: number;
  name: string;
  configuration: Configuration;
  snapshot: number;
  isFavorite: boolean;
  isActive: boolean;
  userId: number;
  file?: any;
  createdAt?: Date;
  updatedAt?: Date;
};

export interface Configuration {
  template_state: string;
}

export type TemplateState = {
  loading: boolean;
  templates: Template[];
  saveTemplateRequestStatus: RequestStatus;
  error?: string;
};

export enum templateSnapshot {
  physicianIndividual = 1,
  physicianOrganizational = 2,
  locationClinic = 3,
  taxonomy = 4,
}

export interface TemplateFormValues {
  cardId?: number;
  cardValue?: string;
  checkboxes?: string[];
  name?: string;
  providerId?: number;
  reportId?: string;
  templateState?: string;
  viewMode?: boolean;
}
